import React, { useEffect, useState } from 'react';
import Header from './Header';
import useApi from '../hooks/useApi';
import { endpoints } from '../utils/utils';
import UserService from '../services/user.service';
import { useNotifications } from '../context/NotificationProvider';
import { useNavigate } from 'react-router-dom';
import { PhoneInput } from 'react-international-phone';
import btnInfo from "../assets/images/icon-info.svg";
import Modal from "react-modal";
import useLogout from '../hooks/useLogout';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import IconButton from '@mui/material/IconButton';
import { useTranslation } from 'react-i18next';

const toDateInputValue = (date = new Date()) => {
  const localDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
  return localDate.toISOString().split('T')[0];
};

const EditProfile = () => {
  //const [user, setUser] = useState({});
  const api = useApi();
  const notify = useNotifications();
  const navigate = useNavigate();
  const [originalPhone, setOriginalPhone] = useState("");
  const [showPhoneConfirm, setShowPhoneConfirm] = useState(false);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const logout = useLogout();
  const { i18n, t } = useTranslation('editprofil');
  const maxBirthdate = toDateInputValue();

  const [showPasswords, setShowPasswords] = useState({
    oldPassword: false,
    password: false,
    confirmPassword: false
  });

  const signOut = async () => {
    await logout();
    navigate('/login');
  }
  const [formData, setFormData] = useState({
    firstname: "",
    lastname: "",
    phone: "",
    civility: null,
    birthdate: "",
    email: "",
    oldPassword: "",
    password: "",
    confirmPassword: "",
    id: "",
    acceptedCgu: false
  });

  const customStyles = {
    content: {
      width: "33%",
      top: "50%",
      padding: "40px",
      left: "50%",
      right: "auto",
      bottom: "auto",
      borderRadius: "10px",
      boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
      maxWidth: "450px",
      margin: "auto",
      textAlign: "center",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
    },
  };
  const togglePasswordVisibility = (field) => {
    setShowPasswords(prev => ({
      ...prev,
      [field]: !prev[field]
    }));
  };

  useEffect(() => {
    let isMounted = true;
    const controller = new AbortController();

    const getUsers = async () => {
      try {
        const response = await api.get(endpoints.getProfil);
        if (isMounted) {
          //  setUser(response.data);
          setFormData({
            id: response.data.user.id || "",
            firstname: response.data.user.firstname || "",
            lastname: response.data.user.lastname || "",
            phone: response.data.user.phone || "",
            birthdate: response.data.user.birthdate || "",
            email: response.data.user.email || "",
            civility: response.data.user.civility || "",
            // password: "" // Keeping it empty for security reasons
          });
          setOriginalPhone(response.data.user.phone || "");
          console.log(response.data.user.phone)
        }
      } catch (err) {
        console.error(err);
      }
    };

    getUsers();

    return () => {
      isMounted = false;
      controller.abort();
    };
  }, []);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handlePhoneChange = (value) => {
    setFormData({
      ...formData,
      phone: value,
    });
  };
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (formData.birthdate && formData.birthdate > maxBirthdate) {
      notify.warn(t('birthdateFuture'));
      return;
    }

    if (formData.password || formData.confirmPassword) {
      if (!formData.oldPassword) {
  notify.warn(t('please_enter_current_password'));
        return;
      }

      try {
        const response = await api.post('/verify-password', {
          password: formData.oldPassword,
          client_id: formData.id
        }, {
          headers: { "Content-Type": "application/json" },
        });
        console.log("dd", response)

        if (!response.data.success) {
          notify.warn(t('current_password_incorrect'));
          return;
        }
      } catch (error) {
        notify.error('Une erreur est survenue lors de la vérification du mot de passe.');
        return;
      }
      if (formData.password !== formData.confirmPassword) {
  notify.warn(t('passwords_do_not_match'));
        return;
      }
    }

    if (!formData.acceptedCgu) {
  notify.warn(t('accept_terms_and_privacy'));
      return;
    }

    if (formData.phone !== originalPhone) {
      setShowPhoneConfirm(true);
      return;
    }

    await submitProfileUpdate();
  };

  const handleDeleteAccount = async () => {
    try {
      const response = await UserService.delete(formData.id, api);
      console.log('Profile deleted:', response.data);
      notify.success("Compte supprimé avec succès");
      signOut();
    } catch (err) {
      notify.error("Erreur lors de la suppression du compte");
      console.error("Error deleting account:", err);
    }
  };


  const submitProfileUpdate = async () => {
    const submitData = {
      ...formData,
      birthdate: formData.birthdate || null,
    };
    delete submitData.confirmPassword;

    try {

      if (formData.phone !== originalPhone) {
        const submitDataPhone = {
          ...formData,
          phone: formData.phone,
          status: 'PENDING_PHONE_VERIFICATION',
          birthdate: formData.birthdate || null,
        };
        const response = await UserService.update(formData.id, submitDataPhone, api);
        console.log('Phone and profile updated successfully:', response.data);
        setOriginalPhone(null);
        notify.success('Numéro de téléphone mis à jour. Vous allez être déconnecté.');
        signOut();
        return;
      }
      else {
        const response = await UserService.update(formData.id, submitData, api);
        console.log('Profile updated successfully:', response.data);
      }
      notify.success('Profil mis à jour avec succès');
      navigate('/profile');

    } catch (err) {
      if (err.response?.status === 400 && err.response.data?.message === 'Incorrect old password') {
        notify.error('Mot de passe actuel incorrect');
      } else {
        notify.error('Erreur lors de la mise à jour du profil');
      }
      console.error('Error updating profile:', err);
    }
  };

  const urlsFly = {
    cgu: i18n.language === 'fr' 
      ? 'https://flyspa.ch/conditions-generales-utilisation/' 
      : 'https://flyspa.ch/en/general-terms-of-use/',
    privacy: i18n.language === 'fr' 
      ? 'https://flyspa.ch/politique-de-confidentialite/' 
      : 'https://flyspa.ch/en/privacy-policy/'
  };

  return (
    <>
      <Header />
      <div className="container container-profile edit-profil">
        <div className="name">{t('title')}</div>
        <form className="form" onSubmit={handleSubmit}>
          <div className="sexe">
            <div className="choix">
              <input
                type="checkbox"
                name="civility"
                value="MS"
                id="MS"
                checked={formData.civility === "MS"}
                onChange={(e) => {
                  setFormData((prev) => ({
                    ...prev,
                    civility: prev.civility === "MS" ? null : "MS",
                  }));
                }}
              />
              <label htmlFor="MS">{t('madame')}</label>
            </div>
            <div className="choix">
              <input
                type="checkbox"
                name="civility"
                value="MR"
                id="MR"
                checked={formData.civility === "MR"}
                onChange={(e) => {
                  setFormData((prev) => ({
                    ...prev,
                    civility: prev.civility === "MR" ? null : "MR",
                  }));
                }}
              />
              <label htmlFor="MR">{t('monsieur')}</label>
            </div>
          </div>
          <div className="form-group">
            <label>{t('firstname')}*</label>
            <input
              type="text"
              name="firstname"
              value={formData.firstname}
              onChange={handleChange}
              placeholder="John"
            />
          </div>
          <div className="form-group">
            <label>{t('lastname')}*</label>
            <input
              type="text"
              name="lastname"
              value={formData.lastname}
              onChange={handleChange}
              placeholder="Appleseed"
            />
          </div>
          <div className="form-group">
            <label>{t('phone')}*</label>
            <PhoneInput
              name="phone"
              value={formData.phone}
              forceDialCode={true}
              disableCountryGuess={false}
              onChange={handlePhoneChange}
              className="phone-input"
              inputMode="tel"
              maxLength={15}
              placeholder="+41 123 4555 6334"
            />
          </div>
          <div className="form-group">
            <label>{t('email')}*</label>
            <input
              type="email"
              disabled
              value={formData.email}
              onChange={handleChange}
              placeholder="john.appleseed@gmail.com"
            />
          </div>
          <div className="form-group password-field">
            <label>{t('oldPassword')}*</label>
            <div className="password-input-container">
              <input
                type={showPasswords.oldPassword ? "text" : "password"}
                name="oldPassword"
                value={formData.oldPassword}
                onChange={handleChange}
                placeholder={t('oldPasswordPlaceholder')}
              />
              <IconButton
                onClick={() => togglePasswordVisibility('oldPassword')}
                size="small"
                style={{
                  position: 'absolute',
                  right: 0,
                  top: '50%',
                  transform: 'translateY(-50%)'
                }}
              >
                {showPasswords.oldPassword ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            </div>
          </div>
          <div className="form-group password-field">
            <label>{t('newPassword')}*</label>
            <div className="password-input-container">
              <input
                type={showPasswords.password ? "text" : "password"}
                name="password"
                value={formData.password || ''}
                onChange={handleChange}
                placeholder={t('newPasswordPlaceholder')}
              />
              <IconButton
                onClick={() => togglePasswordVisibility('password')}
                size="small"
                style={{
                  position: 'absolute',
                  right: 0,
                  top: '50%',
                  transform: 'translateY(-50%)'
                }}
              >
                {showPasswords.password ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            </div>
          </div>
          <div className="form-group password-field">
            <label>{t('confirmPassword')}*</label>
            <div className="password-input-container">
              <input
                type={showPasswords.confirmPassword ? "text" : "password"}
                name="confirmPassword"
                value={formData.confirmPassword}
                onChange={handleChange}
                placeholder={t('confirmPasswordPlaceholder')}
              />
              <IconButton
                onClick={() => togglePasswordVisibility('confirmPassword')}
                size="small"
                style={{
                  position: 'absolute',
                  right: 0,
                  top: '50%',
                  transform: 'translateY(-50%)'
                }}
              >
                {showPasswords.confirmPassword ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            </div>
          </div>
          <div className="form-group">
            <label>{t('birthdate')}</label>
            <input
              type="date"
              name="birthdate"
              value={formData.birthdate}
              onChange={handleChange}
              placeholder="01/01/1971"
              max={maxBirthdate}
            />
          </div>
          <div className="form-check">
            <input
              type="checkbox"
              name="acceptedCgu"
              id="cgu"
              checked={formData.acceptedCgu}
              onChange={handleChange}
            />
            <label htmlFor="cgu">
              {t('accept')} &nbsp;
              <a href={urlsFly.privacy} target="_blank" rel="noopener noreferrer">
                {t('cgu')}
              </a>
              &nbsp;{t('and')}&nbsp;
              <a href={urlsFly.privacy} target="_blank" rel="noopener noreferrer">
                {t('privacy')}
              </a>
              &nbsp;*
            </label>
          </div>
          <div className="form-submit">
            <input type="submit" value={t('submit')} />
          </div>
        </form>
        <a onClick={() => setShowDeleteConfirm(true)} className="btn-remove-user">
          {t('deleteAccount')}
        </a>
      </div>

      {/* Phone Modal */}
      {showPhoneConfirm && (
        <Modal
          isOpen={showPhoneConfirm}
          onRequestClose={() => setShowPhoneConfirm(false)}
          style={customStyles}
          contentLabel={t('confirmPhone')}
        >
          <div className="zone-not-served-container">
            <div className="popup-box">
              <button onClick={() => setShowPhoneConfirm(false)} className="close-btn">
                <img src={btnInfo} alt={t('close')} />
              </button>
              <p style={{ marginBottom: '10px' }}>
                {t('phoneChanged')} <strong>{formData.phone}</strong>.
              </p>
              <p style={{ marginBottom: '20px' }}>{t('logoutWarning')}</p>
              <div className="modal-actions">
                <button onClick={() => setShowPhoneConfirm(false)}>{t('cancel')}</button>
                <button onClick={submitProfileUpdate}>{t('confirm')}</button>
              </div>
            </div>
          </div>
        </Modal>
      )}

      {/* Delete Modal */}
      <Modal
        isOpen={showDeleteConfirm}
        onRequestClose={() => setShowDeleteConfirm(false)}
        style={customStyles}
        contentLabel={t('confirmDelete')}
      >
        <div className="zone-not-served-container">
          <div className="popup-box">
            <button onClick={() => setShowDeleteConfirm(false)} className="close-btn">
              <img src={btnInfo} alt={t('close')} />
            </button>
            <p style={{ marginBottom: '10px' }}>{t('deleteConfirm')}</p>
            <p style={{ marginBottom: '20px' }}>{t('deleteWarning')}</p>
            <div className="modal-actions">
              <button onClick={() => setShowDeleteConfirm(false)}>{t('cancel')}</button>
              <button onClick={handleDeleteAccount} className="danger">{t('delete')}</button>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
}

export default EditProfile;
